import config from "../../../../config/config"
import { handleResponse } from "../../../../utils/handleResponse";
import { checkResponse } from "../../../../utils/checkResponse";
import axios from "axios"
import { authHeader } from "../../../../utils/authHeader";
import { handleError } from "../../../../utils/handleCatch";

export default function timeslots(cartId, day) {
    return (
        axios.get(`${config.baseUrl}/cli/ecommerce/slots/${cartId}?weekDay=${day}`, {
            headers: authHeader()
        })
        .then(handleResponse)
        .then(checkResponse)
            
    );
}